import classNames from "classnames";
import type {SelectedFilter} from "@/entities/catalog";
import {CatalogFilter, type Filter} from "@/features/catalog-filters";
import {CatalogSelectedFilters} from "@/features/catalog-selected-filters";
import {CatalogSort, type CatalogSortDto} from "@/features/catalog-sort";
import {Svg} from "@/shared/ui/Svg";
import {Button} from "@/shared/ui/Button";
import styles from "./CatalogFilters.module.scss";

type Props = {
    filters: Filter[];
    dataSort: CatalogSortDto[];
    insertColors: Record<string, string>;
    isDesktop?: boolean;
    // headerHeight: number;
    className?: string;
    selectedFilters: SelectedFilter[];
    onOpen: () => void;
};

export const CatalogFilters = (
    {
        filters,
        dataSort,
        insertColors,
        isDesktop = false,
        className,
        selectedFilters,
        onOpen,
    }: Props
) => {
    return (
        <div className={classNames(styles.container, className)}>
            <div className={styles.filters}>
                    <Button
                        variant={`tertiary`}
                        size={isDesktop ? `l` : `m`}
                        className={styles.allFiltersButton}
                        onClick={onOpen}
                    >
                        <Svg id={`allFiltersIcon`} className={styles.allFiltersIcon} />
                        <span className={styles.allFiltersName}>Все фильтры</span>
                    </Button>
                <div className={styles.list}>
                    {filters.map((filter) => {
                        return (
                            <CatalogFilter
                                key={filter.key}
                                filter={filter}
                                isDesktop={isDesktop}
                                insertColors={insertColors}
                            />
                        )
                    })}
                </div>
                <div className={styles.sortButton}><CatalogSort dataSort={dataSort} isDesktop={isDesktop} /></div>
                <CatalogSelectedFilters
                    className={styles.chips}
                    size={isDesktop ? `l` : `m`}
                    selectedFilters={selectedFilters}
                />
            </div>
        </div>
    );
}
